import { render, staticRenderFns } from "./BaseRightIcon.vue?vue&type=template&id=6b70b3cb"
import script from "./BaseRightIcon.vue?vue&type=script&lang=js"
export * from "./BaseRightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports